import script from "./returnTurnover.vue?vue&type=script&setup=true&lang=ts"
export * from "./returnTurnover.vue?vue&type=script&setup=true&lang=ts"

import "./returnTurnover.vue?vue&type=style&index=0&id=6440568e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6440568e"]])

export default __exports__